import React from 'react';

/**
 * Componente que exibe o indicador de progresso das etapas do agendamento
 * 
 * @param {Object} props - Propriedades do componente
 * @param {number} props.currentStep - Etapa atual (1, 2 ou 3)
 * @param {string} props.primaryColor - Cor primária do tema
 * @param {boolean} props.isAdmin - Indica se está no modo admin
 * @param {boolean} props.simpleMode - Se verdadeiro, exibe uma versão simplificada com apenas barras
 */
const ProgressIndicator = ({ 
  currentStep = 1, 
  primaryColor = '#4F46E5',
  isAdmin = false,
  simpleMode = false
}) => {
  // Se estiver no modo admin, usar azul em vez da cor primária
  const activeColor = isAdmin ? '#3B82F6' : primaryColor;
  
  const steps = [
    { id: 1, label: 'Serviços' },
    { id: 2, label: 'Agenda' },
    { id: 3, label: 'Dados' }
  ];
  
  // Modo simplificado com apenas barras horizontais
  if (simpleMode) {
    return (
      <div className="w-full flex px-6 py-2">
        {steps.map((step) => (
          <div 
            key={step.id}
            className={`h-1 flex-1 mx-1 rounded-full ${step.id <= currentStep ? 'bg-blue-500' : 'bg-gray-300'}`}
          />
        ))}
      </div>
    );
  }
  
  // Versão original com círculos e texto
  return (
    <div className="flex items-center justify-between mb-8 px-4">
      {steps.map((step, index) => {
        const isActive = step.id === currentStep;
        const isCompleted = step.id < currentStep;
        
        // Determinar cores com base no estado da etapa
        const circleColor = isActive || isCompleted ? activeColor : '#E5E7EB';
        const textColor = isActive ? activeColor : isCompleted ? '#4B5563' : '#9CA3AF';
        
        return (
          <React.Fragment key={step.id}>
            {/* Linha de conexão (exceto para o primeiro item) */}
            {index > 0 && (
              <div 
                className="flex-1 h-0.5 mx-2" 
                style={{ 
                  backgroundColor: step.id <= currentStep ? activeColor : '#E5E7EB',
                  transition: 'background-color 0.3s ease'
                }}
              />
            )}
            
            {/* Círculo e texto */}
            <div className="flex flex-col items-center">
              <div 
                className="flex items-center justify-center w-8 h-8 rounded-full text-white font-medium text-sm mb-1.5"
                style={{ 
                  backgroundColor: circleColor,
                  transition: 'background-color 0.3s ease'
                }}
              >
                {isCompleted ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  step.id
                )}
              </div>
              <span 
                className="text-xs font-medium"
                style={{ 
                  color: textColor,
                  transition: 'color 0.3s ease'
                }}
              >
                {step.label}
              </span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProgressIndicator; 